import { CSSObject } from "@emotion/react";
import { Button } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";

const ButtonWithTrackEvent = withTrackEvent(Button);

type ReadAloudControlButtonProps = {
  config: {
    disabled?: boolean;
    [key: string]: any;
  };
  iconCss: CSSObject;
};
const ReadAloudControlButton = ({
  config,
  iconCss = {},
}: ReadAloudControlButtonProps) => {
  const { Icon } = config;

  return (
    // @ts-expect-error property objectType is missing
    <ButtonWithTrackEvent {...config}>
      <Icon css={iconCss} />
    </ButtonWithTrackEvent>
  );
};

export default ReadAloudControlButton;
